export default "__VITE_ASSET__D7LE_bJ8__"